module.exports = __webpack_public_path__ + "img/rn.0fa5f0b2.png";